/* eslint-disable */
const devicePX = window.devicePixelRatio >= 3 ? '@3x' : '@2x'
const png = `${devicePX}.png`

const Back_Blue = require(`@/assets/common/Back_Blue${png}`)
const Back_White = require(`@/assets/common/Back_White${png}`)
const Share_Blue = require(`@/assets/common/Share_Blue${png}`)
const Share_White = require(`@/assets/common/Share_White${png}`)
const Unfold = require(`@/assets/common/Unfold${png}`)
const Unfold_Blue = require(`@/assets/common/Unfold_Blue${png}`)
const Unfold_Light = require(`@/assets/common/Unfold_Light${png}`)
const Fold = require(`@/assets/common/fold${png}`)
const Loading = require(`@/assets/common/Loading_46${png}`)
const NoWeb = require(`@/assets/common/NoWeb${png}`)
const Chevron_Blue = require(`@/assets/common/Chevron_blue_24${png}`)
const Chevron_Down_Blue = require(`@/assets/common/chevron_down_blue_24${png}`)
const Product_Plan = require(`@/assets/common/Product_Plan${png}`)
const Logo_Blue = require(`@/assets/common/Logo_blue${png}`)
const Logo_Color = require(`@/assets/common/Logo_color${png}`)
const Logo_Gray = require(`@/assets/common/Logo_gray${png}`)
const Connect_App = require(`@/assets/common/Connect_App${png}`)
const Flag_HK = require(`@/assets/common/Flag_HK${png}`)
const Flag_CN = require(`@/assets/common/Flag_CN${png}`)
const Flag_OMA = require(`@/assets/common/Flag_OMA${png}`)
const Flag_US = require(`@/assets/common/Flag_US${png}`)
const Switch = require(`@/assets/common/Switch${png}`)
const No_Record = require(`@/assets/common/No_Record${png}`)
const No_Product = require(`@/assets/common/No_Product${png}`)
const Alert = require(`@/assets/common/Alert${png}`)
const Alert_Rd_Red = require(`@/assets/common/alert_rd_red_16${png}`)
const Clear = require(`@/assets/common/Clear${png}`)
const Done_Rd_Blue = require(`@/assets/common/Done_rd_blue_16${png}`)
const Done_rd_blue_Big = require(`@/assets/common/Done_rd_blue_70${png}`)
const Reject_Rd_Gray = require(`@/assets/common/reject_rd_gray_16${png}`)
const Reject_Rd_Gray_Big = require(`@/assets/common/reject_rd_gray_70${png}`)
const Glyphs_Left= require(`@/assets/common/Glyphs_left_rd${png}`)
const Glyphs_Right = require(`@/assets/common/Glyphs_right_rd${png}`)
const Default_Avatar = require(`@/assets/common/Default_Avatar_Neutral${png}`)
const Checkbox_Selected = require(`@/assets/common/Checkbox_selected${png}`)
const Checkbox_Unselected = require(`@/assets/common/Checkbox_unselected${png}`)
const Search = require(`@/assets/common/Search${png}`)
const NoSearch = require(`@/assets/common/NoSearch${png}`)
const FT_Active = require(`@/assets/common/FT_Active${png}`)
const FT_Inactive = require(`@/assets/common/FT_Inactive${png}`)
const UT_Active = require(`@/assets/common/UT_Active${png}`)
const UT_Inactive = require(`@/assets/common/UT_Inactive${png}`)
const PDF = require(`@/assets/common/PDF${png}`)
const Circle = require(`@/assets/common/Circle${png}`)
const Circle_Disabled = require(`@/assets/common/circle_disabled${png}`)
const Done_Circle = require(`@/assets/common/Done_circle${png}`)
const FPS = require(`@/assets/common/FPS${png}`)
const Done_Rd = require(`@/assets/common/done_rd${png}`)
const Right = require(`@/assets/common/Right${png}`)
const CHECK = require(`@/assets/common/CHECK${png}`)
const Upload_add = require(`@/assets/common/Upload_add${png}`)
const ClaimApplication = require(`@/assets/common/claimApplication${png}`)
const ClaimApplicationRecord = require(`@/assets/common/claimApplicationRecord${png}`)
const Compile = require(`@/assets/common/compile${png}`)
export {
  Back_Blue,
  Back_White,
  Share_Blue,
  Share_White,
  Unfold,
  Unfold_Blue,
  Unfold_Light,
  Fold,
  Loading,
  NoWeb,
  Chevron_Blue,
  Chevron_Down_Blue,
  Product_Plan,
  Logo_Blue,
  Logo_Color,
  Logo_Gray,
  Connect_App,
  Flag_HK,
  Flag_CN,
  Flag_US,
  Flag_OMA,
  Switch,
  No_Product,
  No_Record,
  Alert,
  Alert_Rd_Red,
  Clear,
  Done_Rd_Blue,
  Done_rd_blue_Big,
  Reject_Rd_Gray,
  Reject_Rd_Gray_Big,
  Glyphs_Left,
  Glyphs_Right,
  Default_Avatar,
  Checkbox_Selected,
  Checkbox_Unselected,
  Search,
  NoSearch,
  FT_Active,
  FT_Inactive,
  UT_Active,
  UT_Inactive,
  PDF,
  Circle,
  Circle_Disabled,
  Done_Circle,
  FPS,
  Done_Rd,
  Right,
  CHECK,
  Upload_add,
  ClaimApplication,
  ClaimApplicationRecord,
  Compile
}
